
export default {
  props: ["baseInfo", "headerData", "wmkcData", "footerData"],
  data() {
    return {
      languageIsShow: true,
    };
  },
  methods: {
    updataShow() {
      this.languageIsShow = !this.languageIsShow;
    },
  },
};
